import React from "react";
import Spinner from "../../../components/presentationals/Spinner";
import {
  Grid,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Typography,
  Paper,
  IconButton,
} from "@material-ui/core";
import ReplyIcon from "@material-ui/icons/Reply";
import CallRounded from "@material-ui/icons/CallRounded";
import CustomizedDialog from "./CustomizedDialog";
import TablePaginationActions from "./TablePagination/index";
import Error from "../../../components/Error/index";
import { rupeeFormatNumber } from "../../../utils/common";

const RetailerPerformaceTableView = (props) => {
  const {
    filterValue,
    timestampArr,
    retailerPerformanceObj,
    retailerData,
    classes,
    showTable,
    page,
    backToTop20,
    section,
    renderTableHeader,
    headerKeys,
    rowsPerPage,
    sortedRetailerData,
    StyledTableCell,
    retailerNameColorCoding,
    otherRetailerLink,
    handlePaginationOption,
    columnTotal,
    top20ColumnTotal,
    handleChangePage,
    handleChangeRowsPerPage,
  } = props;

  return (
    <div
      className="whitebox wow fadeInUp"
      data-wow-delay=".6s"
      data-wow-duration="0.7s"
      data-cy="retailer-performance"
    >
      <div className="subtitlebox">
        <div className="subtitleboxChild">{`${filterValue.selectedPartnerRoleName} Dashboard`}</div>
        <div className="card-timestamp" data-cy="timestamp">
          <i className="fa fa-history mr-2"></i>
          {timestampArr &&
            timestampArr[0] &&
            timestampArr[0].tileTimestamp?.split(".")[0]}
        </div>
      </div>
      {retailerPerformanceObj && retailerPerformanceObj.loading ? (
        <Spinner />
      ) : (
        <Grid
          container
          alignContent="space-around"
          justify="center"
          data-cy="pagination-table"
        >
          <Grid item sm={12} className="table">
            {retailerData && retailerData.length ? (
              <TableContainer className={classes.container} component={Paper}>
                {showTable && page !== 0 ? (
                  <IconButton aria-label="back" onClick={backToTop20}>
                    <ReplyIcon color="primary" />
                  </IconButton>
                ) : null}
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="custom pagination table"
                >
                  <caption className={classes.rows}>
                    <CustomizedDialog section={section} />
                  </caption>
                  {renderTableHeader(headerKeys)}
                  <TableBody>
                    {(rowsPerPage > 0
                      ? sortedRetailerData.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                      : sortedRetailerData
                    ).map((row, index) => (
                      <TableRow key={page * rowsPerPage + index + 1}>
                        <StyledTableCell
                          style={{
                            color: retailerNameColorCoding(row),
                            width: 300,
                            textAlign: "left",
                          }}
                          component="th"
                          scope="row"
                          className={classes.rows}
                        >
                          {page * rowsPerPage + index + 1}.
                          {row.retailerName !== "0" ? row.retailerName : null}
                        </StyledTableCell>
                        <StyledTableCell className={classes.rows}>
                          {+row.phoneNo ? (
                            <Link href={`tel:${row.phoneNo}`}>
                              <CallRounded style={{ color: "blue" }} />
                            </Link>
                          ) : null}
                        </StyledTableCell>
                        <StyledTableCell className={classes.rows}>
                          {row.ftdOrders}
                        </StyledTableCell>
                        <StyledTableCell className={classes.rows}>
                          {row.d1SimAct}
                        </StyledTableCell>
                        {+row.mtdSimAct < 0.9 * +row.lmtdSimAct ? (
                          <StyledTableCell
                            style={{ color: "#FF0000" }}
                            className={classes.rows}
                          >
                            {row.mtdSimAct}
                          </StyledTableCell>
                        ) : +row.mtdSimAct >= 0.9 * +row.lmtdSimAct &&
                          +row.mtdSimAct <= +row.lmtdSimAct ? (
                          <StyledTableCell
                            style={{ color: "#FFBF00" }}
                            className={classes.rows}
                          >
                            {row.mtdSimAct}
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell
                            style={{ color: "#000" }}
                            className={classes.rows}
                          >
                            {row.mtdSimAct}
                          </StyledTableCell>
                        )}

                        <StyledTableCell className={classes.rows}>
                          {row.lmtdSimAct}
                        </StyledTableCell>
                        <StyledTableCell className={classes.rows}>
                          {row.lfmSimAct}
                        </StyledTableCell>
                        {+row.mtdJiophoneAct < 0.9 * +row.lmtdJiophoneAct ? (
                          <StyledTableCell
                            style={{ color: "#FF0000" }}
                            className={classes.rows}
                          >
                            {row.mtdJiophoneAct}
                          </StyledTableCell>
                        ) : +row.mtdJiophoneAct >= 0.9 * +row.lmtdJiophoneAct &&
                          +row.mtdJiophoneAct <= +row.lmtdJiophoneAct ? (
                          <StyledTableCell
                            style={{ color: "#FFBF00" }}
                            className={classes.rows}
                          >
                            {row.mtdJiophoneAct}
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell
                            style={{ color: "#000" }}
                            className={classes.rows}
                          >
                            {row.mtdJiophoneAct}
                          </StyledTableCell>
                        )}

                        {+row.walletBalance < 1000 ? (
                          <StyledTableCell
                            className={classes.rows}
                            style={{ color: "#FF0000" }}
                          >
                            {row.walletBalance}
                          </StyledTableCell>
                        ) : +row.walletBalance >= 1000 &&
                          +row.walletBalance <= 1499 ? (
                          <StyledTableCell
                            className={classes.rows}
                            style={{ color: "#FFBF00" }}
                          >
                            {row.walletBalance}
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell className={classes.rows}>
                            {rupeeFormatNumber(row.walletBalance)}
                          </StyledTableCell>
                        )}

                        {+row.jiophoneStock < 3 ? (
                          <StyledTableCell
                            style={{ color: "#FF0000" }}
                            className={classes.rows}
                          >
                            {row.jiophoneStock}
                          </StyledTableCell>
                        ) : +row.jiophoneStock >= 3 &&
                          +row.jiophoneStock <= 5 ? (
                          <StyledTableCell
                            style={{ color: "#FFBF00" }}
                            className={classes.rows}
                          >
                            {row.jiophoneStock}
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell className={classes.rows}>
                            {row.jiophoneStock}
                          </StyledTableCell>
                        )}
                      </TableRow>
                    ))}

                    {page === 0 ? (
                      <>
                        <TableRow>
                          <TableCell
                            key="OtherRetailers"
                            style={{ width: 160, textAlign: "left" }}
                            className={classes.rows}
                            colSpan={2}
                          >
                            <Typography className={classes.root}>
                              {otherRetailerLink ? (
                                <Link href="#" onClick={handlePaginationOption}>
                                  <strong style={{ color: "blue" }}>
                                    Other Retailers+
                                  </strong>
                                </Link>
                              ) : (
                                "Other Retailers+"
                              )}
                            </Typography>
                          </TableCell>
                          {Object.entries(columnTotal).map((column, index) => {
                            // console.log(column, top20ColumnTotal);
                            return (
                              <TableCell
                                style={{ width: 160 }}
                                className={classes.rows}
                                key={index}
                              >
                                <strong>
                                  {column[0] === "walletBalance"
                                    ? rupeeFormatNumber(
                                        column[1] - top20ColumnTotal[column[0]]
                                      )
                                    : column[1] - top20ColumnTotal[column[0]]}
                                </strong>
                              </TableCell>
                            );
                          })}
                        </TableRow>
                        <TableRow>
                          <TableCell
                            key="Total"
                            component="th"
                            scope="row"
                            className={classes.rows}
                            style={{ textAlign: "left" }}
                          >
                            <strong>Total</strong>
                          </TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          ></TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          >
                            <strong>{columnTotal.ftdOrders}</strong>
                          </TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          >
                            <strong>{columnTotal.d1SimAct}</strong>
                          </TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          >
                            <strong>{columnTotal.mtdSimAct}</strong>
                          </TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          >
                            <strong>{columnTotal.lmtdSimAct}</strong>
                          </TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          >
                            <strong>{columnTotal.lfmSimAct}</strong>
                          </TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          >
                            <strong>{columnTotal.mtdJiophoneAct}</strong>
                          </TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          >
                            <strong>
                              {rupeeFormatNumber(columnTotal.walletBalance)}
                            </strong>
                          </TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          >
                            <strong>{columnTotal.jiophoneStock}</strong>
                          </TableCell>
                        </TableRow>
                      </>
                    ) : null}
                  </TableBody>
                  {page !== 0 ? (
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          rowsPerPageOptions={[]}
                          colSpan={12}
                          count={sortedRetailerData.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          SelectProps={{
                            inputProps: { "aria-label": "rows per page" },
                            native: true,
                          }}
                          onChangePage={handleChangePage}
                          onChangeRowsPerPage={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                        />
                      </TableRow>
                    </TableFooter>
                  ) : null}
                </Table>
              </TableContainer>
            ) : (
              <Error error={retailerPerformanceObj.error} />
            )}
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default RetailerPerformaceTableView;
